// Media Assets Configuration
// All video and image URLs centralized for easy replacement

export const mediaAssets = {
  // Videos
  videos: {
    hero: 'https://customer-assets.emergentagent.com/job_smart-site-intel/artifacts/qruey5mx_7255101-hd_2048_1080_30fps.mp4',
    productDemo: 'https://customer-assets.emergentagent.com/job_smart-site-intel/artifacts/uk08kpfv_3195703-hd_1920_1080_25fps.mp4',
    security: 'https://customer-assets.emergentagent.com/job_smart-site-intel/artifacts/s7l5hzdr_14969565_1920_1080_24fps.mp4',
    industry: 'https://customer-assets.emergentagent.com/job_smart-site-intel/artifacts/78qezhzm_14711661_1920_1080_30fps.mp4',
    agriculture: 'https://customer-assets.emergentagent.com/job_smart-site-intel/artifacts/riw97jwv_14490146_1920_1080_25fps.mp4',
  },

  // Hero Images (fallback/poster)
  heroImages: {
    main: 'https://images.pexels.com/photos/19317897/pexels-photo-19317897.jpeg',
    security: 'https://images.unsplash.com/photo-1618482914248-29272d021005',
    industry: 'https://images.unsplash.com/photo-1764114908655-9a26d32750a0',
    agriculture: 'https://images.unsplash.com/photo-1560493676-04071c5f467b',
    healthcare: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef',
  },

  // Solution Images
  solutionImages: {
    security: {
      hero: 'https://images.unsplash.com/photo-1618482914248-29272d021005',
      card: 'https://images.unsplash.com/photo-1665848383782-1ea74efde68f',
      detail: 'https://images.pexels.com/photos/19317897/pexels-photo-19317897.jpeg'
    },
    industry: {
      hero: 'https://images.unsplash.com/photo-1764114908655-9a26d32750a0',
      card: 'https://images.unsplash.com/photo-1740914994657-f1cdffdc418e',
      detail: 'https://images.unsplash.com/photo-1740914994162-0b2a49280aeb'
    },
    agriculture: {
      hero: 'https://images.unsplash.com/photo-1560493676-04071c5f467b',
      card: 'https://images.unsplash.com/photo-1693720401167-498b469f1d73',
      detail: 'https://images.pexels.com/photos/2518861/pexels-photo-2518861.jpeg'
    },
    healthcare: {
      hero: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef',
      card: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d',
    }
  },

  // Industry Images
  industryImages: {
    infrastructure: 'https://images.unsplash.com/photo-1536099629323-44806c1ea264',
    warehouse: 'https://images.unsplash.com/photo-1740914994657-f1cdffdc418e',
    logistics: 'https://images.unsplash.com/photo-1606964212858-c215029db704',
    commercial: 'https://images.pexels.com/photos/269077/pexels-photo-269077.jpeg',
    agriculture: 'https://images.unsplash.com/photo-1560493676-04071c5f467b',
  }
};

export default mediaAssets;
